import React from 'react'
import Navbar from './navbar';
import './header.css';

const header = () => {
  return (

    <> 
     <div>
      
    <header className="header">
      <Navbar />
     
    </header>

    </div> </>
   
  )
}

export default header
